document.addEventListener("DOMContentLoaded", () => {

    const section = document.querySelector("#ecoma-showcase");

    const tabs = section.querySelectorAll(".ecoma-tab");

    const products = section.querySelectorAll(".ecoma-product");

    tabs.forEach(tab => {

        tab.addEventListener("click", function(){

            const id = this.dataset.tab;

            tabs.forEach(btn=>btn.classList.remove("active"));

            this.classList.add("active");

            products.forEach(product=>{

                product.classList.remove("active");

                if(product.dataset.content===id){

                    product.classList.add("active");

                    section.style.background = product.dataset.bg;

                }

            });

        });

    });

    const first = section.querySelector(".ecoma-product.active");

    if(first){

        section.style.background = first.dataset.bg;

    }

});